import { Field } from "formik";
import Select from "react-select";
import { Form } from "react-bootstrap";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PHONE_LIMIT = 15;

export default function UserProfile({ formField, setFieldValue, values }) {
  const { phoneNumber, accountType } = formField;

  const { t } = useTranslation();
  const userType = [
    { key: 1, value: t("admin") },
    { key: 2, value: t("basic") },
  ];
  const { auth } = useSelector((state) => state);

  const userTypeAvailable = userType?.filter((type) => +type.key >= auth.user.account_type);

  const handleChange = (event) => {
    setFieldValue("accountType", +event.target.value);
  };
  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex align-item-center w-100 gap-2">
        <Form.Group className="w-50">
          <Form.Label> {t(phoneNumber.label)}</Form.Label>
          <Field
            type="text"
            name={phoneNumber.name}
            className="form-control"
            maxLength={PHONE_LIMIT}
          />
        </Form.Group>
        <Form.Group className="w-50">
          <Form.Label> {t(accountType.label)}</Form.Label>
          <Field
            as="select"
            className="form-control "
            name={accountType.name}
            onChange={handleChange}
          >
            {userTypeAvailable?.map((userType) => (
              <option key={userType.key} value={userType.key}>
                {userType.value}
              </option>
            ))}
          </Field>
        </Form.Group>
      </div>
    </div>
  );
}
